

























































































import { Component, Vue } from 'vue-property-decorator'
import { queryNews, queryCourseType, getCourse, addLearnRecord, addFinishLearnRecord } from '@/api/api'
import styleDialog from '@/components/styleDialog.vue'
const videoType = ['mp4', 'avi']

@Component({
  components: {
    styleDialog
  }
})
export default class TrainingCourse extends Vue {
  courseList: Array<any> = [] // 课程列表
  secondLevelList: Array<any> = [] // 二级分类
  thirdLevelList: Array<any> = [] // 三级分类
  fileList: Array<any> = [] // 文件列表
  courseCurrentIndex: number = 0
  secondLeveCurrentIndex: number = 999
  thirdLevelCurrentIndex: number = 999
  courseId: string = ''
  pageSize: number = 15 // 分页组件的page-size
  total: number = 0 // 分页组件的total
  dialogVisible: Boolean = false // 是否显示文件模态框
  checkFile: any = {
    id: '', // 课程ID
    name: '', // 课程名字
    url: '', // 课程地址
    type: ''
  }

  mounted() {
    this._onload().finally(() => {
      this._loading().close()
    })
  }

  /**
   * 选择课程大类
   * @param id    课程ID
   * @param index 当前课程的index
   */
  async selectCourse(id: string, index: number): Promise<any> {
    if (this.courseId !== id) {
      this._loading()
      this.courseCurrentIndex = index
      this.secondLeveCurrentIndex = 999
      this.thirdLevelCurrentIndex = 999
      this.secondLevelList = []
      this.thirdLevelList = []

      this._queryCourseType(id).then((res: any) => {
        for (let i = 0, len = res.length; i < len; i++) {
          this.secondLevelList.push({
            id: res[i].course_type_id,
            name: res[i].course_type_name
          })
        }
      })

      await this._getCourse(id)
      this._loading().close()
      this.courseId = id
    }
  }

  /**
   * 选择二级目录
   * @param id    课程ID
   * @param index 当前课程的index
   */
  async selectSecondLeve(id: string, index: number): Promise<any> {
    if (this.courseId !== id) {
      this._loading()
      this.secondLeveCurrentIndex = index
      this.thirdLevelCurrentIndex = 999
      this.thirdLevelList = []

      if (index !== 999) {
        this._queryCourseType(id).then(res => {
          for (let i = 0, len = res.length; i < len; i++) {
            this.thirdLevelList.push({
              id: res[i].course_type_id,
              name: res[i].course_type_name
            })
          }
        })
      }

      await this._getCourse(id)
      this._loading().close()
      this.courseId = id
    }
  }

  /**
   * 选择三级目录
   * @param id    课程ID
   * @param index 当前课程的index
   */
  async selectThirdLeve(id: string, index: number): Promise<any> {
    if (this.courseId !== id) {
      this._loading()
      this.thirdLevelCurrentIndex = index

      await this._getCourse(id)
      this._loading().close()
      this.courseId = id
    }
  }

  /**
   * 在新标签页打开课程文件
   * @param file // 文件信息
   */
  openFile(file: any): void {
    console.log(file)
    this._addLearnRecord(file.course_id)
    if (file.course_file_type === 'pdf' || videoType.includes(file.course_file_type)) {
      this.dialogVisible = true
      this.checkFile.id = file.course_id
      this.checkFile.name = file.course_name
      this.checkFile.url = file.link_path
      this.checkFile.type = file.course_file_type
      return
    }
    window.open(file.link_path)
    this._addFinishLearnRecord(file.course_id)
  }

  /**
   * 完成学习
   */
  completeLearn(e: any): void {
    console.log(e)
    this.dialogVisible = !this.dialogVisible
  }

  /**
   * 换页
   */
  async changePage(page: number): Promise<any> {
    this._loading()
    await this._getCourse(this.courseId, page)
    this._loading().close()
  }

  /**
   * 页面初始化
   */
  async _onload(): Promise<any> {
    this._loading()
    await this._queryCourseType(0).then(async (res: any) => {
      for (let i = 0, len = res.length; i < len; i++) {
        this.courseList[i] = {
          id: res[i].course_type_id,
          name: res[i].course_type_name,
          children: [],
          currentChildrenIndex: ''
        }
      }
    })

    await this._queryCourseType(this.courseList[0].id).then(res => {
      for (let i = 0, len = res.length; i < len; i++) {
        this.secondLevelList.push({
          id: res[i].course_type_id,
          name: res[i].course_type_name
        })
      }
    })

    await this._getCourse(this.courseList[0].id)
    this.courseId = this.courseList[0].id
  }

  /**
   * 查询课程
   */
  async _queryCourseType(parent_id: any): Promise<any> {
    return queryCourseType({ parent_id }).then((res: any) => {
      if (res.data.code === 101) return res.data.result
    })
  }

  /**
   * 查询课程内容
   */
  async _getCourse(course_type_id: string, page: number = 1, size: number = this.pageSize): Promise<any> {
    return getCourse({
      course_type_id,
      page,
      size
    }).then((res: any) => {
      this.fileList = res.data.result.records
      this.total = res.data.result.total
    })
  }

  /**
   * 接口 添加学习记录
   * @param course_id 课程ID
   */
  _addLearnRecord(id: string): void {
    addLearnRecord({ course_id: id })
  }

  /**
   * 接口 添加学习记录
   * @param course_id 课程ID
   */
  _addFinishLearnRecord(id: string): void {
    addFinishLearnRecord({ course_id: id })
  }

  /**
   * 显示loading
   */
  _loading(): any {
    const vm = this
    this.$loading({
      lock: true,
      text: '加载中',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    return {
      close() {
        vm.$loading({}).close()
      }
    }
  }
}
